import { AllocationsDashboard } from '../components/Allocations/AllocationsDashboard';

export const AllocationsSection = () => {
  return <AllocationsDashboard />;
};
